<wbo-edit-page [title]="model.data.contact.firstName" (addingAnother)="addingAnother($event)">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.member.edit.formation.details', formControlNames: ''}">
        <wbo-member-edit-details></wbo-member-edit-details>
    </fui-formation-group-template>
</wbo-edit-page>
